export interface UserRole {
    user_id:    number;
    userRoles:  UserRole[];
}

export interface UserRole {
    role_id:   number;
    role_name: RoleName;
}

export enum RoleName {
    developer = 'developer',
    superadmin = 'superadmin', 
    webadmin = 'webadmin',
    webdept = 'webdept',
    localadmin = 'localadmin',
    businessdev = 'businessdev',
    marketingdept = 'marketingdept',
    accountingdept = 'accountingdept',
    webformaccess = 'feat-webform-access'
}

export interface UserRoleResponse {
    status: number,
    message: string,
    success:    boolean,
    user_id:    number,
    userRoles:  UserRole[]
}
